import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=83ad4158&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=83ad4158&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ad4158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ad4158')) {
      api.createRecord('83ad4158', component.options)
    } else {
      api.reload('83ad4158', component.options)
    }
    module.hot.accept("./productManage.vue?vue&type=template&id=83ad4158&scoped=true", function () {
      api.rerender('83ad4158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/mall/productManage.vue"
export default component.exports